import { useState } from 'react'
import { requestMagicLink } from '../api'

interface LoginProps {
  logoUrl?: string | null
  onLinkSent: (email: string) => void
}

export default function Login({ logoUrl, onLinkSent }: LoginProps) {
  const [email, setEmail] = useState('')
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState('')

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    if (!email.trim()) return
    setBusy(true)
    setErr('')
    try {
      await requestMagicLink(email.trim())
      onLinkSent(email.trim())
    } catch (ex: unknown) {
      setErr(ex instanceof Error ? ex.message : 'Something went wrong.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="p-login-wrap">
      <div className="p-login-card">
        <div className="p-login-logo">
          {logoUrl
            ? <img src={logoUrl} alt="The Successful Bookkeeper" />
            : <span className="p-login-brand-name">The Successful Bookkeeper</span>
          }
        </div>
        <h1 className="p-login-heading">Your program roadmap</h1>
        <p className="p-login-sub">Enter your email and we'll send you a sign-in link. No password needed.</p>

        {err && <div className="p-error">{err}</div>}

        <form className="p-login-form" onSubmit={submit}>
          <div>
            <label htmlFor="loginEmail">Email address</label>
            <input
              id="loginEmail"
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              autoFocus
              required
              disabled={busy}
            />
          </div>
          <button type="submit" className="p-btn p-btn-cta p-btn-full" disabled={busy || !email.trim()}>
            {busy ? 'Sending…' : 'Send sign-in link'}
          </button>
        </form>
      </div>
    </div>
  )
}
